import { useEffect } from 'react';
import { useAppContext } from '../context/AppContext';

export const useKeyboardShortcuts = () => {
  const { dispatch } = useAppContext();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Check for Cmd/Ctrl + K for export command palette
      if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
        event.preventDefault();
        dispatch({ type: 'TOGGLE_EXPORT_MODAL' });
        return;
      }

      // Check for Escape to close modals
      if (event.key === 'Escape') {
        // You could add logic here to close any open modals
        // For now, we'll handle this in individual modal components
        return;
      }
    };

    // Add event listener
    document.addEventListener('keydown', handleKeyDown);

    // Cleanup
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [dispatch]);
};